<template>
  <div>
    <canvas ref="chartCanvasRef"></canvas>
  </div>
</template>
<script>
import { Chart } from 'chart.js'
import { formatNumber } from '../../../lib/utils'

export default {
  name: 'MostSoldItemsChart',
  props: {
    data: {
      type: Object,
      default: () => ({
        labels: [],
        backgroundColor: [],
        data: [],
        datasetLabel: '',
      }),
    },
  },
  data() {
    return {
      chart: null,
      config: {
        type: 'bar',
        data: {
          labels: [],
          datasets: [
            {
              label: 'Quantities Sold',
              data: [],
              backgroundColor: [],
              borderWidth: 0,
            },
          ],
        },
        options: {
          legend: {
            labels: {
              fontColor: '#666',
            },
          },
          tooltips: {
            callbacks: {
              label: (tooltipItem, data) => {
                const datasetLabel = data.datasets[tooltipItem.datasetIndex].label || ''
                const value = formatNumber(tooltipItem.yLabel)
                return `${datasetLabel}: ${value}`
              },
            },
          },
          scales: {
            xAxes: [
              {
                type: 'category',
              },
            ],
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                  callback: (val) => {
                    return formatNumber(val)
                  },
                },
              },
            ],
          },
          responsive: true,
          maintainAspectRatio: false,
        },
      },
    }
  },
  mounted() {
    const canvas = this.$refs.chartCanvasRef
    this.chart = new Chart(canvas, {
      ...this.config,
    })
    this.update()
  },
  methods: {
    update() {
      const config = { ...this.config }
      config.data.labels = [...this.data.labels]
      const dataset = config.data.datasets[0]
      dataset.data = [...this.data.data]
      dataset.backgroundColor = [...this.data.backgroundColor]
      this.config = config
      this.chart.data = config.data
      this.chart.update()
    },
  },
}
</script>
